import { useCallback, useEffect, useState } from 'react';
import { ChargeCategoriesService } from '../api/services/ChargeCategoriesService';
import type { ChargeCategory } from '../types/sales.types';
import { DEFAULT_CHARGE_CATEGORY_CODE } from '../utils/sales/order-charges.utils';

const FALLBACK_CATEGORIES: ChargeCategory[] = [
  {
    code: DEFAULT_CHARGE_CATEGORY_CODE,
    label: 'Otros Cargos',
    isDefault: true,
    sortOrder: 1,
  },
];

export const useChargeCategories = (enabled: boolean) => {
  const [categories, setCategories] = useState<ChargeCategory[]>(FALLBACK_CATEGORIES);
  const [isLoading, setIsLoading] = useState(false);

  const loadCategories = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await ChargeCategoriesService.chargeCategoriesControllerFindAllActive();
      if (Array.isArray(response) && response.length > 0) {
        setCategories(response);
      } else {
        setCategories(FALLBACK_CATEGORIES);
      }
    } catch {
      setCategories(FALLBACK_CATEGORIES);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (enabled) {
      void loadCategories();
    }
  }, [enabled, loadCategories]);

  return {
    categories,
    isLoading,
    reloadCategories: loadCategories,
  };
};
